
export const crosshairCursor = (val) =>{
    if(document.getElementById('map') === undefined){
        return // Harita Bulunamadı
    }
    if(val){
        document.getElementById('map').style.cursor = 'crosshair'
    } else {
        document.getElementById('map').style.cursor = 'default'
    }
}